import { isPlainObject, isFunction } from "../utils";

function once(fn) {
  if (typeof fn === 'function') {
    let _invoked = false;

    return function __invokableFunctionWithOnlyOneInvocation(...args) {
      if (!_invoked && (_invoked = true)) return fn(...args);
    }
  }

  return fn;
}

function type(obj) {
  return Object.prototype.toString.call(obj)
    .replace(/^\[object\s+(.+?)]$/i, '$1')
    .toLowerCase();
}

function parseObjectByType(targetObject, typeSchema) {
  targetObject = isPlainObject(targetObject) ? targetObject : {};

  if (isPlainObject(typeSchema)) {
    return Object.keys(targetObject).reduce((parsedOptions, key) => {
      const _value = targetObject[key];
      let [ _type, _default ] = [].concat(typeSchema[key]);

      _type = type(_type) === 'string' ? _type.trim() : undefined;
      _default = _type && type(_default) === _type ? _default : undefined;

      parsedOptions[key] = _type
        ? _value
        : type(_value) === _type
          ? _value
          : _default;

      return parsedOptions;
    }, {});
  }

  return targetObject;
}

function __parseChargeCallbacks__(callbacks) {
  return isPlainObject(callbacks)
    ? callbacks
    : isFunction(callbacks) ? { onComplete: callbacks } : {};
}

function parseChargeCallbacks(callbacks, appendCallbacks) {
  let data, appendData;
  ({ data, ...callbacks } = __parseChargeCallbacks__(callbacks));
  ({ data: appendData, ...appendCallbacks } = __parseChargeCallbacks__(appendCallbacks));

  Object.keys(appendCallbacks).forEach(key => {
    const callback = callbacks[key];
    const appendCallback = appendCallbacks[key];

    if (isFunction(appendCallback)) {
      callbacks[key] = isFunction(callback)
        ? function(...args) {
          appendCallback.call(this, ...args);
          callback.call(this, ...args);
        }
        : appendCallback;
    }
  });

  try {
    Object.defineProperty(callbacks, 'data', {
      configurable: true,
      enumerable: true,
      get() {
        return ({
          ...isPlainObject(data) ? data : {},
          ...isPlainObject(appendData) ? appendData : {}
        });
      }
    });
  } catch (e) {}

  return callbacks;
}

export {
  once,
  parseChargeCallbacks,
  parseObjectByType,
  type
}
